import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import MapRender from '@blade-sxp/map-new/index.vue';
import { EModel } from '@blade-sxp/map-new/frontEndRender/utils/loadModels';
import { ELineLevel, getLineConfig } from '@blade-sxp/map-new/frontEndRender/utils/line';
import MapLocationLabel from '@blade/common/components/map-doms/location-label.vue';
import { EMarkerType } from '@blade-sxp/map-new/interfaces/ueMap';
let MapRenderTest = class MapRenderTest extends Vue {
    weather = 'foggy';
    map;
    //  http://192.168.12.10:8181/webclient/?appliId=1310996129730527232”
    mapUrl = 'http://10.164.22.29:8181?appid=1310996129730527232';
    // mapUrl = `http://192.168.12.10:8181?appid=1310996129730527232`;
    // mapUrl: string = 'http://10.8.33.85:8181?appid=1232323361976090624'; // mapImg; // '10.8.10.29:8080'; // '10.8.10.28:8080';
    mapType = '3D_UE'; // 2D
    // mapUrl: string = mapImg; // '10.8.10.29:8080'; // '10.8.10.28:8080';
    // mapType = '2D';
    backEndMarkerList = [];
    backEndHeatMapList = [{ id: '1', vertices: [-529.3502734375, -808.2628125, 0], radius: 100, rippleNumber: 5, color: [0, 1, 0, 1] }];
    backEndHighlightList = [];
    backEndRoiList = [];
    floorValue = '';
    weatherConfig = {
        rain: {
            strength: 1,
            speed: 1,
            raindropSize: 1,
        },
        snow: { strength: 1, speed: 1, snowflakeSize: 1 },
        fog: {
            fogDensity: 0.1,
            fogHeightFalloff: 0.5,
            fogStartDistance: 10,
            fogOpacity: 0.2,
            fogColor: [1, 1, 1, 1],
        },
        cloud: {
            cloudDensity: 1,
            cloudThickness: 0.5,
        },
    };
    mainAngle = {
        target: {
            x: 46.642093658447266,
            y: 24.763423919677734,
            z: '-14.983',
        },
        camera: {
            x: '94.409',
            y: '19.224',
            z: '396.137',
        },
    };
    // mainAngle: any = {
    //   camera: {
    //     x: -661.950312,
    //     y: 542.430313,
    //     z: 98.565273,
    //   },
    //   target: {
    //     x: -89.000626,
    //     y: 136.001511,
    //     z: 0,
    //   },
    // };
    criticleLineConfig = getLineConfig(ELineLevel.CRITICAL);
    majorLineConfig = getLineConfig(ELineLevel.MAJOR);
    minorLineConfig = getLineConfig(ELineLevel.MINOR);
    normalLineConfig = getLineConfig(ELineLevel.NORMAL);
    defaultLineConfig = getLineConfig(ELineLevel.DEFAULT);
    activeLineConfig = getLineConfig(ELineLevel.ACTIVE);
    roiList = [];
    // tagList = [
    //   {
    //     id: 'tag1',
    //     vertices: {
    //       x: 0.5,
    //       y: 0.5,
    //       z: 0,
    //     },
    //     visible: true,
    //     vueConfig: {
    //       instance: MapLocationLabel,
    //       data: { title: 'tag1', icon: null, isShowLocationIcon: true },
    //     },
    //   },
    // ];
    tagList = [
        {
            id: 'deviceAbnormal',
            vertices: {
                x: 46.644661180277694,
                y: 24.762954522794836,
                z: -14.737616607761302,
            },
            type: EMarkerType.DEVICE_ABNORMAL,
            visible: true,
        },
        {
            id: 'deviceOnline',
            vertices: {
                x: 46.64418289448841,
                y: 24.763675186299047,
                z: -14.405466313763863,
            },
            type: EMarkerType.DEVICE_ONLINE,
        },
        {
            id: 'alert',
            vertices: {
                x: 46.64281304769631,
                y: 24.763809485979642,
                z: -14.605847833310763,
            },
            type: EMarkerType.ALERT,
        },
        {
            id: 'queue',
            vertices: {
                x: 46.64278106328593,
                y: 24.76200039870442,
                z: -15.6920785670435,
            },
            text: '33',
            type: EMarkerType.QUEUE,
        },
        {
            id: 'zoneTag',
            vertices: {
                x: 46.64395333774322,
                y: 24.761225004734722,
                z: -15.9147067657375,
            },
            text: 'zoneTag',
            type: EMarkerType.AREA,
        },
        {
            id: 'lineTag',
            sourceId: 'line-criticle',
            vertices: {
                x: 46.64395333774322,
                y: 24.761225004734922,
                z: -15.9147067657375,
            },
            bgcColor: '#11ff00',
            text: '0.0',
            type: EMarkerType.TEXT,
            visible: true,
        },
    ];
    queueList = [
        // {
        //   id: 'queue-' + 1,
        //   taskId: 1,
        //   vertices: {
        //     x: 0.5,
        //     y: 0.5,
        //     z: 0,
        //   },
        //   visible: true,
        //   vueConfig: {
        //     instance: TimeLabel,
        //     data: { timeTxt: '30', ceil: 'min' },
        //     emitMethods: {
        //       onClick: () => {
        //         console.log('click queue');
        //       },
        //     },
        //   },
        // },
        {
            id: 'alerts-' + 2,
            taskId: 2,
            vertices: {
                x: 0.5,
                y: 0.5,
                z: 0,
            },
            visible: true,
            vueConfig: {
                instance: MapLocationLabel,
                data: {
                    isShowTitle: false,
                    icon: {
                        id: 'icon1',
                        url: '',
                    },
                },
                emitMethods: {
                    onClick: () => {
                        console.log('click queue');
                    },
                },
            },
        },
    ];
    lineList = [
        {
            id: 'line-criticle',
            visible: true,
            vertices: [
                {
                    x: 46.6420989815162,
                    y: 24.763398567125176,
                    z: -14.997236733381934,
                },
                {
                    x: 46.641977202328434,
                    y: 24.763420650025544,
                    z: -15.008977392267735,
                },
                {
                    x: 46.64196932993679,
                    y: 24.763254741458873,
                    z: -15.109503932157795,
                },
            ],
            ...this.criticleLineConfig,
            lineType: 'basic',
            zIndex: 1,
            onMouseEnter: (e) => {
                console.log('onMouseEnter', e);
            },
        },
        {
            id: 'line-major',
            visible: true,
            vertices: [
                {
                    x: 0.3,
                    y: 0.1,
                    z: 0,
                },
                {
                    x: 0.3,
                    y: 0.3,
                    z: 0,
                },
                {
                    x: 0.3,
                    y: 0.5,
                    z: 0,
                },
                {
                    x: 0.3,
                    y: 0.7,
                    z: 0,
                },
            ],
            ...this.majorLineConfig,
            lineType: 'dash',
            zIndex: 2,
        },
        {
            id: 'line-minor',
            visible: true,
            vertices: [
                {
                    x: 0.5,
                    y: 0.1,
                    z: 0,
                },
                {
                    x: 0.5,
                    y: 0.3,
                    z: 0,
                },
                {
                    x: 0.5,
                    y: 0.5,
                    z: 0,
                },
                {
                    x: 0.5,
                    y: 0.7,
                    z: 0,
                },
            ],
            ...this.minorLineConfig,
            // lineType: 'dash',
            zIndex: 3,
        },
        {
            id: 'line-normal',
            visible: true,
            vertices: [
                {
                    x: 0.7,
                    y: 0.1,
                    z: 0,
                },
                {
                    x: 0.7,
                    y: 0.3,
                    z: 0,
                },
                {
                    x: 0.7,
                    y: 0.5,
                    z: 0,
                },
                {
                    x: 0.7,
                    y: 0.7,
                    z: 0,
                },
            ],
            ...this.normalLineConfig,
            lineType: 'dash',
            zIndex: 4,
        },
        {
            id: 'line-default',
            visible: true,
            vertices: [
                {
                    x: 0.9,
                    y: 0.1,
                    z: 0,
                },
                {
                    x: 0.9,
                    y: 0.3,
                    z: 0,
                },
                {
                    x: 0.9,
                    y: 0.5,
                    z: 0,
                },
                {
                    x: 0.9,
                    y: 0.7,
                    z: 0,
                },
            ],
            ...this.defaultLineConfig,
            lineType: 'dash',
            zIndex: 5,
        },
        {
            id: 'line3',
            visible: true,
            vertices: [
                {
                    x: 0.1,
                    y: 0.5,
                    z: 0,
                },
                {
                    x: 0.3,
                    y: 0.5,
                    z: 0,
                },
                {
                    x: 0.5,
                    y: 0.5,
                    z: 0,
                },
                {
                    x: 0.7,
                    y: 0.5,
                    z: 0,
                },
                {
                    x: 0.9,
                    y: 0.5,
                    z: 0,
                },
            ],
            ...this.activeLineConfig,
            lineType: 'dash',
            zIndex: 6,
        },
    ];
    iconList = [
        {
            id: 'icon1',
            vertices: { x: 0.6, y: 0.6, z: 0 },
            visible: true,
            vueConfig: {
                instance: MapLocationLabel,
                data: {
                    title: 'test label',
                    isShowTitle: true,
                    icon: {
                        id: 'icon1',
                        url: '',
                    },
                    titleStyle: {
                        color: 'skyblue',
                    },
                },
                emitMethods: {
                    onClick: () => {
                        console.log('icon1 onClick');
                    },
                },
            },
        },
        {
            id: 'label1',
            vertices: { x: 0.8, y: 0.8, z: 0 },
            visible: true,
            vueConfig: {
                instance: MapLocationLabel,
                data: {
                    title: 'test label',
                    isShowTitle: true,
                    titleStyle: {
                        color: 'skyblue',
                    },
                },
                emitMethods: {
                    onClick: () => {
                        console.log('icon1 onClick');
                    },
                },
            },
        },
    ];
    pathList = [
        {
            id: 'path1',
            covering: {
                key: [],
            },
            coveringCount: 2,
            speed: 1,
            width: 2,
            type: 'ARROW2',
            cycle: false,
            show: true,
            patrol: false,
            isClick: 'mapSetting',
            vertices: [
                {
                    x: -871.35236,
                    y: 80.43,
                    z: 103.525035,
                },
                {
                    x: -901.35236,
                    y: 80.43,
                    z: 83.525035,
                },
                {
                    x: -921.35236,
                    y: 80.43,
                    z: 107.315224,
                },
                {
                    x: -933.44763,
                    y: 80.43,
                    z: 57.315224,
                },
                {
                    x: -973.44763,
                    y: 80.43,
                    z: 77.315224,
                },
                {
                    x: -953.44763,
                    y: 80.43,
                    z: 47.315224,
                },
                {
                    x: -903.44763,
                    y: 80.43,
                    z: 37.315224,
                },
                {
                    x: -883.44763,
                    y: 80.43,
                    z: 57.315224,
                },
            ],
        },
    ];
    heatMapList = [
        {
            id: 'heatMap1',
            radius: 50,
            colorStops: [
                { offset: 0, color: '#ff0000' },
                { offset: 0.4, color: '#ffaa00' },
                { offset: 0.6, color: '#00ff00' },
                { offset: 0.7, color: '#00ff00' },
                // { offset: 1.0, color: '#0000ff' },
            ],
            vertices: { x: 46.64155960083008, y: 24.76380157470703, z: 0 },
        },
    ];
    dispose() {
        this.map?.map?.dispose();
    }
    onMouseLeave(data) {
        console.log('onMouseLeave data', data);
        this.tagList.forEach((i) => (i.visible = false));
    }
    onMouseEnter(data) {
        console.log('onMouseEnter data', data);
        const { type, target } = data;
        const tag = this.tagList.find((i) => i?.sourceId === target?.id);
        if (tag) {
            console.log('onMouseEnter tag', tag);
            tag.vertices = target?.vertices;
            tag.visible = true;
        }
    }
    openClickMap() {
        if (!this.map)
            return;
        this.map.map.openClick((data) => {
            console.log('openClickMap data', data);
        });
    }
    closeClickMap() {
        if (!this.map)
            return;
        this.map.map.closeClick();
    }
    zoomChage(val) {
        if (val > 0)
            this.map.zoomIn(val);
        else {
            this.map.zoomOut(Math.abs(val));
        }
    }
    openDraw(type) {
        if (!this.map?.map)
            return;
        console.log('openDraw start');
        this.map?.map?.openDrawer({
            type: type,
            drawEnd: (data = {}) => {
                const { type = '', positions = [], position = null } = data;
                console.log('drawEnd client  data', data);
                switch (type) {
                    case 'line':
                        {
                            const line = {
                                id: 'line-criticle-' + new Date().getTime(),
                                show: true,
                                vertices: positions,
                                ...this.criticleLineConfig,
                            };
                            this.lineList.push(line);
                        }
                        break;
                    case 'roi':
                        {
                            const roi = {
                                id: 'roi-test',
                                name: 'tempRoi',
                                visible: true,
                                vertices: positions,
                            };
                            this.roiList.push(roi);
                        }
                        break;
                    case 'circle':
                        {
                            const heatMap = {
                                id: ('heatMap-' + new Date().getTime()),
                                radius: data?.radius,
                                visible: true,
                                colorStops: [
                                    { offset: 0.2, color: '#ff0000' },
                                    { offset: 0.4, color: '#ffaa00' },
                                    { offset: 0.6, color: '#00ff00' },
                                    { offset: 1.0, color: '#0000ff' },
                                ],
                                vertices: position,
                            };
                            this.heatMapList.push(heatMap);
                        }
                        break;
                    case 'ellipse': {
                        const { heading, minorAxis, majorAxis, position } = data;
                        const heatMap = {
                            id: ('ellipse-heatMap-' + new Date().getTime()),
                            heading,
                            minorAxis,
                            majorAxis,
                            type: 'ellipse',
                            visible: true,
                            colorStops: [
                                { offset: 0.2, color: '#ff0000' },
                                { offset: 0.4, color: '#ffaa00' },
                                { offset: 0.6, color: '#00ff00' },
                                { offset: 1.0, color: '#0000ff' },
                            ],
                            vertices: position,
                        };
                        this.heatMapList.push(heatMap);
                    }
                }
                this.map?.map?.closeDrawer?.();
            },
        });
    }
    changeMapType() {
        this.mapType = '3D-Three.js';
        this.mapUrl = '/gltf/JYC1New/JYC11/ST_0620.gltf';
        this.pathList = [
            {
                id: 'path1',
                // covering: true,
                coveringCount: 3,
                speed: 1,
                width: 2,
                type: 'ARROW2',
                covering: {
                    key: [EModel.CAR, EModel.FEMALE, EModel.MALE, EModel.MALE1],
                },
                cycle: false,
                show: true,
                patrol: true,
                isClick: 'mapSetting',
                vertices: [
                    { x: 164.53369, y: 3.399994, z: -231.891 },
                    { x: -169.66269, y: 3.399994, z: -239.60005 },
                    { x: -358.73657, y: 3.399994, z: -236.0013 },
                    { x: -492.0655, y: 2.7464073, z: -117.148346 },
                    { x: -492.0655, y: 2.7464073, z: -117.148346 },
                ],
            },
            {
                id: 'path2',
                covering: {
                    key: [EModel.CAR, EModel.VEHICLE50, EModel.VEHICLE45],
                },
                coveringCount: 2,
                speed: 1,
                width: 2,
                type: 'ARROW1',
                cycle: false,
                show: true,
                patrol: true,
                isClick: 'mapSetting',
                vertices: [
                    { x: 306.78033, y: 1.646082, z: -81.07217 },
                    { x: 22.831148, y: 1.4000006, z: -116.92509 },
                    { x: 52.923843, y: 3.399994, z: -206.3805 },
                    { x: -308.8, y: 3.399994, z: -204.47766 },
                    { x: -451.87616, y: 1.4000007, z: -86.65102 },
                ],
            },
        ];
    }
    zoomReset() {
        this.map?.zoomReset();
    }
    setMainAngle(mainAngle) {
        // this.map?.setMainAngle({
        //   camera: {
        //     x: -675.082188,
        //     y: -855.358438,
        //     z: 102.976367,
        //   },
        //   target: {
        //     x: -649.937805,
        //     y: -880.502808,
        //     z: 67.454826,
        //   },
        // });
        console.log(111);
        this.mainAngle = mainAngle;
        // this.mainAngle = {
        //   camera: {
        //     x: -661.950312,
        //     y: 542.430313,
        //     z: 98.565273,
        //   },
        //   target: {
        //     x: -89.000626,
        //     y: 136.001511,
        //     z: 0,
        //   },
        // };
    }
    changeIcon() {
        this.backEndMarkerList = [
            {
                id: 'S_KAFD_116_JZ_01_S_KAFD_116_JZ_01_Other_8',
                styleType: 4,
                range: [1, 2000],
                text: '天府新区B5',
                popupURL: 'http://10.8.98.36:8080/backRender/card',
                popupSize: [400, 300],
                vertices: [-432.89188, -485.79376, 283.63834],
            },
            {
                id: 'S_KAFD_116_JZ_01_S_KAFD_116_JZ_01_Other_9',
                styleType: 3,
                range: [1, 2000],
                text: '天府新区B5',
                popupURL: 'https://www.bilibili.com',
                popupSize: [400, 300],
                vertices: [-432.89188, -485.79376, 383.63834],
            },
            {
                id: 'S_KAFD_116_JZ_01_S_KAFD_116_JZ_01_Other_10',
                styleType: 5,
                range: [1, 2000],
                text: '天府新区B5',
                popupURL: 'https://www.bilibili.com',
                popupSize: [400, 300],
                vertices: [-432.89188, -485.79376, 483.63834],
            },
            {
                id: 'S_KAFD_116_JZ_01_S_KAFD_116_JZ_01_Other_11',
                styleType: 6,
                range: [1, 2000],
                text: '天府新区B5',
                popupURL: 'https://www.bilibili.com',
                popupSize: [400, 300],
                vertices: [-432.89188, -485.79376, 583.63834],
            },
            {
                id: 'S_KAFD_116_JZ_01_S_KAFD_116_JZ_01_Other_12',
                styleType: 7,
                range: [1, 2000],
                text: '天府新区B5',
                popupURL: 'https://www.bilibili.com',
                popupSize: [400, 300],
                vertices: [-432.89188, -485.79376, 683.63834],
            },
            {
                id: 'S_KAFD_116_JZ_01_S_KAFD_116_JZ_01_Other_13',
                styleType: 8,
                range: [1, 2000],
                text: '天府新区B5',
                popupURL: 'https://www.bilibili.com',
                popupSize: [400, 300],
                vertices: [-432.89188, -485.79376, 783.63834],
            },
            {
                id: '11111',
                styleType: 11,
                range: [1, 2000],
                text: '天府新区B5',
                popupURL: 'https://www.bilibili.com',
                popupSize: [400, 300],
                vertices: [-529.3502734375, -808.2628125, 0],
            },
            {
                id: '222222',
                styleType: 9,
                range: [1, 2000],
                text: '天府新区B5',
                popupURL: 'https://www.bilibili.com',
                popupSize: [400, 300],
                vertices: [-232.89188, -185.79376, 283.63834],
            },
            {
                id: '2222223',
                styleType: 10,
                range: [1, 2000],
                text: '天府新区B3',
                popupURL: 'https://www.bilibili.com',
                popupSize: [400, 300],
                vertices: [-932.89188, -185.79376, 283.63834],
            },
            {
                id: 'S_KAFD_403_JZ_01_01_014_47',
                BuildChooseMode: 'build',
                tileLayerName: '403',
                styleType: 2,
                range: [1, 2000],
                text: '高新区B',
                vertices: [-708.27, -932.2969, 77.68343],
            },
            {
                id: 'S_KAFD_403_JZ_01_01_014_44',
                BuildChooseMode: 'build',
                tileLayerName: '403',
                styleType: 1,
                range: [1, 2000],
                text: '高新区A',
                vertices: [-508.27, -932.2969, 77.68343],
            },
        ];
    }
    async getMainAngle() {
        console.log('getMainAngle client', await this.map.getMainAngle());
    }
    handleHighlight() {
        this.backEndHighlightList = [
            {
                id: 'S_KAFD_214_JZ_01_015_55',
                BuildChooseMode: 'floor',
                tileLayerName: '214',
                meshId: 'S_KAFD_214_JZ_01_015_55',
                highlightColor: [0.43137254901960786, 1, 0.16470588235294117, 1],
            },
            {
                id: 'S_KAFD_116_JZ_01_S_KAFD_116_JZ_01_Other_8',
                BuildChooseMode: 'build',
                tileLayerName: '116',
                highlightColor: [0.43137254901960786, 0, 0.16470588235294117, 1],
            },
            {
                id: 'S_KAFD_214_JZ_01_020_65',
                BuildChooseMode: 'build',
                tileLayerName: '214',
                highlightColor: [0, 1, 0.16470588235294117, 1],
            },
            {
                id: 'S_KAFD_214_JZ_01_021_67',
                BuildChooseMode: 'floor',
                tileLayerName: '214',
                meshId: 'S_KAFD_214_JZ_01_021_67',
                highlightColor: [0, 0, 0.16470588235294117, 1],
            },
            {
                id: 'S_KAFD_109_JZ_01_016_68',
                BuildChooseMode: 'floor',
                tileLayerName: '109',
                meshId: 'S_KAFD_109_JZ_01_016_68',
                highlightColor: [0.43137254901960786, 1, 0.16470588235294117, 1],
            },
            {
                id: 'S_KAFD_403_JZ_01_01_014_47',
                BuildChooseMode: 'build',
                tileLayerName: '403',
                highlightColor: [0.43137254901960786, 1, 0.16470588235294117, 1],
            },
        ];
    }
    changeRoi() {
        const list = [
            {
                id: '141',
                styleType: 'line',
                vertices: [
                    [-337.0678, -367.83875, 87.14269],
                    [-367.2494, -609.4153, 14.831524],
                    [-296.50095, -621.3053, 14.616406],
                    [-273.8528, -511.74875, 121.024025],
                    [-340.44156, -368.4994, 87.4634],
                    [-337.4122, -367.90625, 86.548454],
                ],
                style: 3,
            },
            {
                id: '140',
                styleType: 'ripple',
                vertices: [
                    [-480.73907, -695.54315, 16.895702],
                    [-648.4175, -672.9891, 20.034765],
                    [-699.1228, -777.0275, 16.598204],
                    [-493.81876, -780.9597, 14.614453],
                    [-480.77625, -778.5375, 14.614531],
                ],
                style: 3,
            },
            {
                id: '130',
                styleType: 'ripple',
                vertices: [
                    [-677.7478, -268.98563, 20.580938],
                    [-546.71655, -223.275, 40.456192],
                    [-571.4803, -378.46814, 20.694063],
                    [-653.3594, -415.4347, 21.435293],
                    [-680.20905, -418.35187, 57.03701],
                    [-680.20905, -418.35187, 57.03701],
                ],
                style: 3,
            },
            {
                id: '128',
                styleType: 'ripple',
                vertices: [
                    [-321.49374, -789.8072, 20.645937],
                    [-175.14, -767.7531, 44.065548],
                    [-152.86656, -820.6978, 45.972576],
                    [-158.1728, -841.6316, 20.788671],
                    [-340.97406, -878.03876, 20.793673],
                    [-360.7203, -835.84406, 19.623163],
                    [-360.7203, -835.84406, 19.623163],
                ],
                style: 3,
            },
        ];
        this.backEndRoiList = list;
        setTimeout(() => {
            this.backEndRoiList = [];
        }, 2000);
    }
    mapClick(e) {
        console.log('mapClick eee', e);
    }
    clearHeatMap() {
        this.backEndHeatMapList = [];
    }
    async onload(map) {
        this.map = map;
        const res = await this.map?.map?.getZoneTreeData();
        console.log('onload getZoneTreeData', res);
        // this.map?.map?.hoverLine((res: any) => {
        //   const tag = this.tagList.find((i) => i.sourceId === res.id);
        //   if (tag) {
        //     console.log('onload hover line res', res, 'tag', tag);
        //     tag.visible = true;
        //   }
        // });
        // console.log('onload map ===', map);
    }
    changeMapUrl() {
        this.mapUrl = '10.8.10.29:8080';
    }
    drawPath(type) {
        this.map?.drawPath(type);
    }
    setSection(index) {
        console.log(Number(this.floorValue));
        this.map?.setSection('A9744DB543F4D4AB01F732966764EF56', Number(this.floorValue));
    }
    resetSection() {
        this.map?.resetSection();
    }
    async getAllFloor() {
        const result = await this.map?.getAllFloor('A9744DB543F4D4AB01F732966764EF56');
        console.log('result', result);
    }
    openDateTime() {
        console.log('openDateTime', this.map);
        this.map?.openDateTime(new Date().getTime());
    }
    closeDateTime() {
        this.map?.closeDateTime(new Date().getTime());
    }
    setWeather(weather) {
        this.weather = weather;
    }
    mounted() {
        // this.mapUrl = '10.8.10.28:8080';
    }
};
MapRenderTest = __decorate([
    Component({
        name: 'MapRenderTest',
        components: { MapRender },
    })
], MapRenderTest);
export default MapRenderTest;
